module.exports = __webpack_public_path__ + "05cf43315f158cb62cf8ac89cd054308.png";